/**
 * A SZEM — a jelszó megjelenítésének jele (#49 folytatása).
 *
 * ⚠️ MIÉRT NEM `👁` EMODZSI. Az emodzsi **színes**, és platformonként MÁS a
 * rajza: a bordó palettában idegen test, és a mérete is a rendszer
 * emodzsi-fontjától függ — ugyanaz a bukásmód, ami a `▸`/`▾` háromszögnél a
 * cégfejléc igazítását elrontotta, csak feltűnőbben. *(Viktor, 2026-09-18.)*
 *
 * Ugyanaz a rács, mint a `Caret`-nél: **24×24, `currentColor`** — a Tabler és
 * a Lucide geometriája. Ha egyszer mégis ikonkönyvtár kell, a csere ennek a
 * két fájlnak a kidobása.
 *
 * A VONAL 2 EGYSÉG, KEREK VÉGEKKEL, a kitöltés `none`: így a gomb
 * szövegszínét veszi fel, és a `--text-2` → `--action` váltás hoveren
 * magától követi.
 */

export function Eye({ off }: { off: boolean }) {
  return (
    // `aria-hidden`: a gomb nevét az `aria-label` adja, az állapotát az
    // `aria-pressed`. Kimondva háromszor hangzana el ugyanaz.
    <svg
      className="icon"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {/* A szemhéj két szimmetrikus íve, benne a pupilla. */}
      <path d="M3 12c2.4-4 5.4-6 9-6s6.6 2 9 6c-2.4 4-5.4 6-9 6s-6.6-2-9-6z" />
      <circle cx="12" cy="12" r="2.5" />
      {/* REJTETT ÁLLAPOT: áthúzás. Nem másik ikon, hanem ugyanaz EGY vonallal
          — a két állapot így nem tud külön életet élni. */}
      {off ? <path d="M4 4l16 16" /> : null}
    </svg>
  );
}
